module.exports = __webpack_public_path__ + "img/icon-categories.6821c7d7.svg";